import { sqConstants } from '../../_constants';

export function salesQuotation(state = {}, action) {
    switch (action.type) {
        case sqConstants.SQ_FETCHING:
            return {
                ...state,
                sqFetching: true
            };
        case sqConstants.SQ_FETCHED:
            return {
                ...state,
                sqFetching: false
            };
        case sqConstants.SQ_SUBMITTING:
            return {
                ...state,
                sqSubmitting: true
            };
        case sqConstants.SQ_SUBMITTED:
            return {
                ...state,
                sqSubmitting: false
            };
        case sqConstants.SQ_TERMS_GENERATING:
            return {
                ...state,
                termsGenerating: true
            };
        case sqConstants.SQ_TERMS_GENERATED:
            return {
                ...state,
                termsGenerating: false
            };
        case sqConstants.SQ_CHARGES_GENERATING:
            return {
                ...state,
                chargesGenerating: true
            };
        case sqConstants.SQ_CHARGES_GENERATED:
            return {
                ...state,
                chargesGenerating: false
            };
        case sqConstants.LIST_OF_SQ:
            return {
                ...state,
                salesQuotations: action.salesQuotations
            };
        case sqConstants.LIST_OF_SQ_AE_ARCHIVE:
            return {
                ...state,
                salesQuotationsArchive: action.salesQuotationsArchive
            };
        case sqConstants.GET_SQ_BY_REFNUM:
            return {
                ...state,
                salesQuotation: action.salesQuotation
            };
        case sqConstants.GET_SQ_WITH_AMEND:
            return {
                ...state,
                SQAmended: action.SQAmended
            };
        case sqConstants.GET_TERMS_BY_CARGO_TYPE:
            return {
                ...state,
                termsAndConditions: action.termsAndConditions
            };
        case sqConstants.SQ_CHARGES:
            return {
                ...state,
                charges: action.charges.charges,
                openVanCharge: action.charges.openVan,
            };
        case sqConstants.CLEAR_CHARGES:
            return {
                ...state,
                charges: []
            };
        case sqConstants.SQ_VIEWER:
            return {
                ...state,
                sqViewer: action.sqViewer
            };
        case sqConstants.SQ_CUSTOMER_GROUP:
            return {
                ...state,
                sqCustomerGroupViewer: action.sqCustomerGroupViewer
            };
        case sqConstants.SQ_REPORTS_BOOKING:
            return {
                ...state,
                sqReportBooking: action.sqReportBooking
            };
        case sqConstants.SQ_UPDATE:
            return {
                ...state,
                sqUpdateData: action.sqUpdateData
            };
        case sqConstants.SQ_PRES_DATA:
            return {
                ...state,
                sqPresData: action.sqPresData
            };
        case sqConstants.SQ_OPEN_VAN:
            return {
                ...state,
                SQOpenVan: action.SQOpenVan
            };
        case sqConstants.SQ_MEMORANDUM:
            return {
                ...state,
                sqMemo: action.sqMemo
            };
        case sqConstants.SQ_LIST_CHARGE:
            return {
                ...state,
                sqListCharge: action.sqListCharge
            };
        case sqConstants.SQ_PROCEED_MEMO:
            return {
                ...state,
                SQProceedMemo: action.SQProceedMemo
            };
        case sqConstants.SQ_LIST_COMPANY_POLICY:
            return {
                ...state,
                sqListCompanyPolicy: action.sqListCompanyPolicy
            };
        case sqConstants.SQ_AGING_AE:
            return {
                ...state,
                aeUser: action.aeUser
            };
        case sqConstants.SQ_AGING_CUSTOMER_PER_AE:
            return {
                ...state,
                customerPerAe: action.customerPerAe
            };
        case sqConstants.SQ_AGING_DATA:
            return {
                ...state,
                AgingData: action.AgingData
            };
        case sqConstants.ALL_SQ_PER_CUSTOMER:
            return {
                ...state,
                AllSQperCustomer: action.AllSQperCustomer
            };
        case sqConstants.SQ_DEACTIVATE:
            return {
                ...state,
                sqDeactive: action.sqDeactive
            };
        case sqConstants.SQ_DEACTIVATED:
        return {
            ...state,
            SQDeactivated: action.SQDeactivated
        };  
        case sqConstants.SQ_DEACTIVATE_LOG:
        return {
            ...state,
            sqDeactiveLog: action.sqDeactiveLog
        };  
        case sqConstants.CLEAR_SQ:
            return {}
        default:
            return state;
    }
}